//bransServices.js

import api from "./api";

export async function getAllBrands(){
    try{
        const response = await api.get("marcas/public/filter/");
        return response.data;
    }catch (error) {
        console.log("Error al obtener las marcas");
        return null;
    }
}